// extracted by mini-css-extract-plugin
export var cardContainer = "_oj-0";
export var cardHeader = "_oj-2";
export var collapsedState = "_oj-3";
export var dragHandle = "_oj-5";
export var dragHandleIcon = "_oj-6";
export var dragging = "_oj-1";
export var titleArea = "_oj-4";